import {
  fetchQueue
} from '../../utils/api'

export default {
  isFocused(state) {
    return state.focused
  },
  isSynced(state) {
    return state.synced
  },
  isReady(state) {
    //return false
    return state.session && state.session.view_state && state.widget && state.widget.theme && state.widget.theme.primary_bg ? true : false
  },
  isConnected(state) {
    return state.connected
  },
  isMinimize(state) {
    return state.minimize
  },
  bindUID(state) {
    return state.connected ? state.uid : null
  },
  bindSID(state) {
    return state.connected && state.visitor ? state.visitor.session_id : null
  },
  getTimeOnPage(state) {
    return state.timeOnPage
  },
  getLastTimeUpdate(state) {
    return state.lastTimeUpdate
  },
  doRoundRobin(state) {
    return state.roundrobin ? state.roundrobin['.value'] : null
  },
  doScroll(state) {
    return state.doScroll
  },
  hasIntegrations(state) {
    let integrations = state.integrations
    let result = false

    if (integrations)
      for (let i in integrations)
        if (i != '.key' && integrations[i])
          result = true

    return result
  },
  getOrgId(state) {
    return state.orgId
  },
  getWidgetId(state) {
    return state.widgetId
  },
  getUID(state) {
    return state.uid
  },
  isSwayChatPopout(state) {
    return state.isPopout
  },
  isTempHidden(state) {
    return state.tempHide
  },
  isBootHidden(state) {
    let h = fetchQueue('hidden')
    return h ? h : state.bootHidden
  },
  isHidden(state) {
    return state.hidden
  },
  getPreview(state) {
    return state.previewImg
  },
  getFiles(state) {
    return state.files
  }
}
